import { useQuery, useQueryClient } from '@tanstack/react-query';
import { syncStudyPlatformVersion } from 'api/study';
import { StudyPlatformVersionSyncResult } from 'interfaces/study';

export const useStudyPlatformVersionSync = (studyId: string | undefined, { enabled }: { enabled: boolean }) => {
  const queryClient = useQueryClient();

  return useQuery<StudyPlatformVersionSyncResult>({
    queryKey: ['studyPlatformVersionSync', studyId],
    queryFn: async () => {
      const result = await syncStudyPlatformVersion(studyId as string);
      if (result.updated) {
        // Awaited so the form never renders against the pre-sync Platform Version.
        await queryClient.invalidateQueries({ queryKey: ['study', studyId] });
      }
      return result;
    },
    enabled: enabled && Boolean(studyId),
    // Every job form opening must sync again.
    cacheTime: 0,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
